
import React from 'react'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Col, Row, Stack } from 'react-bootstrap'

export const RelatedProductsListItem = ({ title, image, path }) => {
  return (
    <Link className="related-product-item" to={path}>
      <Stack direction='vertical'>
        <div className="image d-flex justify-content-center">
          <GatsbyImage alt={title} image={image} />
        </div>
        <h4>{title}</h4>
      </Stack>
    </Link>
  )
}

export const RelatedProductsList = ({ items }) => {
  if (!items || !items.length) {
    return <></>
  }

  return (
    <div className="related-products-container">
      <Row className="mb-3">
        <Col sm={12}>
          <h3 className="title">
            Related Products
          </h3>
        </Col>
      </Row>
      <Row>
        {items.slice(0, 4).map(item => {
          return (
            <Col key={item.id} md={6} lg={3} className="mb-3">
              <RelatedProductsListItem {...item} />
            </Col>
          )
        })}
      </Row>
    </div>
  )
}
